import Navbar from "../../components/Navbar"

function NavLinks() {
  return (
    <div>
        <Navbar/>
    </div>
    
  )
}

export default NavLinks